import KnowUs from "./KnowUs";

export default KnowUs;
